export default class Sort {
	constructor(items) {
		this.items = items ? items : [];
	}

	descByAtribute(atribute) {
		return this.items.sort((a, b) => {
			if (a[atribute] < b[atribute]) {
				return -1;
			}

			if (a[atribute] > b[atribute]) {
				return 1;
			}

			return 0;
		});
	}
}
